import { render, staticRenderFns } from "./EmailForwardersTable.vue?vue&type=template&id=6e7baca8&"
import script from "./EmailForwardersTable.vue?vue&type=script&lang=js&"
export * from "./EmailForwardersTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e7baca8')) {
      api.createRecord('6e7baca8', component.options)
    } else {
      api.reload('6e7baca8', component.options)
    }
    module.hot.accept("./EmailForwardersTable.vue?vue&type=template&id=6e7baca8&", function () {
      api.rerender('6e7baca8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Shared/Email/Forwarders/EmailForwardersTable.vue"
export default component.exports